export { default } from './WindCell';
